import PropTypes from"prop-types";const propTypes={navLabel:PropTypes.string,selected:PropTypes.number,onTabChange:PropTypes.func};export default propTypes;